<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p>A special debt is owed to Jonathan Glover, professor of philosophy from King’s College, London, for his motivation and sustained patient guidance, who provided detailed comments on an earlier draft of this book. I have gained much from my discussions with him, and I am overall grateful to him for his help and support. Needless to say, this does not imply that he agrees with my views, and he should not be responsible for my mistakes.</p><br/>
<p style="text-indent:0em;">I am particularly pleased to acknowledge the encouragement and help I got years ago, from the late Chaim Perelman, professor of philosophy at the Free University of Brussels. I also take this opportunity to express my great appreciation for the opportunity to attend Jacques Bouveresse’s lectures on philosophy of knowledge at the Collège de France. I might never have written this book, had I not acquired during my medical education a genuine vision of medicine and an intellectual heritage from three late outstanding teachers, Professor Henry Tagnon from Brussels Free University, Dr. Mort Lipsett from the National Institute of Health, Bethesda, and Professor Brian MacMahon from the Harvard School of Public Health.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0a11ca25